module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"Něco se pokazilo","track":"Something went wrong"}}